import { TExportExternal } from '~sharedComponents/ExternalReference/common/types/types';
import { defaultConfigs } from '~sharedComponents/ExternalReference/common/defaults/configs';
import { bindToDomElement } from '~sharedComponents/ExternalReference/common/bindToDOMElement';

type TBindUsingDOM = {
    tagName: string;
    tagValue: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    externalProps: TExportExternal<any>;
};

const emptyDefaultConfig = {
    cart: {},
    perlgem: {},
    stardust: {}
};

export const bindUsingDOM = ({ tagName, tagValue, externalProps }: TBindUsingDOM) => {
    let observer: MutationObserver | null = null;
    const { componentName } = externalProps;

    const bindComponent = async () => {
        const rootNode = window.document.querySelector(`[${tagName}=${tagValue}]`) as HTMLElement;
        //@ts-ignore
        const { cart, perlgem, stardust } = window?.site?.config || emptyDefaultConfig;
        const config = { ...defaultConfigs, ...cart, perlgem, stardust };

        if (rootNode) {
            bindToDomElement({ config, componentName, rootNode });
            observer?.disconnect();
            observer = null;
        }
    };

    observer = new MutationObserver(bindComponent);

    try {
        bindComponent();
        const configs = { attributes: true, childList: true, subtree: true };
        observer.observe(window.document, configs);
    } catch (e) {
        console.warn('failed to bind, trying again', { e });
        setTimeout(() => bindUsingDOM({ tagName, tagValue, externalProps }), 100);
    }

    return null;
};
